import { motion } from 'motion/react'
import type { ShopMessageKey } from '../../../i18n'
import SelectCustom, { type SelectOption } from '../../../components/SelectCustom'
import { customerMotionTransition } from '../customer-area'
import type { OrderSortOption } from './ordersListShared'

type TranslateFn = (key: ShopMessageKey, params?: Record<string, string | number>) => string

type OrdersToolbarTopControlsProps = {
  reducedMotion: boolean
  searchValue: string
  sortBy: OrderSortOption
  filtersOpen: boolean
  sortOptions: SelectOption[]
  onSearchChange: (value: string) => void
  onToggleFilters: () => void
  onSortChange: (value: OrderSortOption) => void
  t: TranslateFn
}

export const OrdersToolbarTopControls = ({
  reducedMotion,
  searchValue,
  sortBy,
  filtersOpen,
  sortOptions,
  onSearchChange,
  onToggleFilters,
  onSortChange,
  t,
}: OrdersToolbarTopControlsProps) => (
  <div className="grid gap-2 lg:grid-cols-[minmax(0,1fr)_auto_240px]">
    <label className="min-w-0">
      <span className="sr-only">{t('customer.orders.filters.searchLabel')}</span>
      <input
        value={searchValue}
        onChange={(event) => onSearchChange(event.target.value)}
        placeholder={t('customer.orders.searchPlaceholder')}
        className="ca-input h-9 w-full px-3 text-sm text-(--color-text-primary) placeholder:text-(--color-text-muted)"
      />
    </label>

    <motion.button
      type="button"
      onClick={onToggleFilters}
      whileTap={reducedMotion ? undefined : { scale: 0.985 }}
      transition={customerMotionTransition}
      className="ca-btn-secondary inline-flex h-9 items-center justify-center px-3 text-sm font-semibold"
    >
      {filtersOpen ? t('customer.orders.filters.close') : t('customer.orders.filters.open')}
    </motion.button>

    <label className="min-w-0">
      <span className="sr-only">{t('customer.orders.sort.label')}</span>
      <SelectCustom
        value={sortBy}
        onChange={(value) => onSortChange(value as OrderSortOption)}
        ariaLabel={t('customer.orders.sort.label')}
        options={sortOptions}
        size="sm"
        buttonClassName="h-9 w-full rounded-[10px] text-sm"
      />
    </label>
  </div>
)
